<template>
  <div style="display: flex; height: 100%">
    <!-- 好友列表 -->
    <card
      :key="cardkey"
      style="width:217px"
      v-if="isAdd && !showset"
      :session="session"
      @trigger="()=>{$emit('trigger');show = false}"
      @showmemo="
        (data) => {
          show = true;
          friendobj = data;
          memovalue = data.friendMemo;
        }
      "
    ></card>
    <div style="flex: 1; background-color: #fefefe;height: 99.5%;border-bottom: 1px solid #999;">
      <div style="border-bottom: 1px solid rgb(204, 204, 204);display: flex;justify-content: space-between;">
        <div class="message-head" style="padding: 21.5px 21px;box-sizing: border-box;flex: 3;">
          <span v-if="isFriend && !isemptyShow">{{userList.length>0 ? !isFriend ? ' ' : userList.filter(item => item.id === session.userId)[0].name : ' '}}</span>
          <span v-else>&nbsp;</span>
        </div>
        <span style="flex: 1;display: flex;justify-content: space-around;align-items: center;">
          <img style="cursor: pointer;" :src="require('@/assets/images/mini.png')" alt="最小化" @click="$emit('close')">
          <img style="cursor: pointer;" :src="require('@/assets/images/react.png')"  @click="$emit('toggleFullScreen')">
          <img style="cursor: pointer;" :src="require('@/assets/images/close.png')" alt="关闭" @click="$emit('close')">
        </span>
      </div>
      <!-- 消息展示 -->
      <friend
        ref="friends"
        v-show="show ? false : !isFriend && showFriendsList"
        :receiveData="receiveData"
        @showFriends="$emit('showFriends')"
        @updatebadge="$emit('updatebadge')"
      ></friend>
      <!-- 发送消息框 -->
      <div v-if="show">
        <!-- 头像昵称 -->
        <div class="headmemo">
          <img :src="friendobj.friendHeadportrait" alt="" />
          <span>{{ friendobj.usernickname }}</span>
        </div>
        <!-- 备注 -->
        <div class="memo">
          <span>备注</span>
          <el-input
            size="small"
            placeholder="点击添加备注"
            v-model="memovalue"
            maxlength="20"
          >
            <el-button slot="append" @click="setmemo">确定</el-button>
          </el-input>
        </div>
        <div class="sendmemo">
          <el-button type="primary" @click="$emit('chart',friendobj)">发消息</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 好友列表
import card from "./card";
// 发送消息框
import friend from "./friend";
let vm = {};
export default {
  props: [
    "userList",
    "session",
    "isemptyShow",
    "isFriend",
    "showFriendsList",
    "showMemo",
    "isAdd",
    "showset",
    "receiveData",
  ],
  components: {
    card,
    friend,
  },
  data() {
    vm = this;
    return {
      cardkey:0,
      friendobj: {},
      memovalue: "",
      show: this.showMemo,
    };
  },
  methods: {
    // 添加备注
    setmemo() {
      if(/^[ ]+$/.test(this.memovalue)){
        this.$message({
          type:'warning',
          message:'请填写备注'
        })
        return 
      }
      this.$confirm("确认添加备注?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          this.axios({
            url: this.zuul + "/xyj-im/w/imRelationship/setMemo",
            method: "post",
            params: {
              memo: this.memovalue?this.memovalue:"",
              toUserId: this.friendobj.friendUserId,
              fromUserId: sessionStorage.getItem('chatid'),
            },
          })
            .then((res) => {
              this.cardkey++
              this.$message({
                type: "success",
                message: "添加备注成功",
              });
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.emptyTemp {
  height: 89%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #999;
}
.headmemo{
  margin: 50px;
  border-bottom: 1px solid;
  display: flex;
  align-items: center;
  padding: 0 0 43px 10px;
}
.headmemo > img{
  width: 60px;
  height: 60px;
}
.headmemo>span{
  margin-left: 35px;
}
.memo {
  display: flex;
  align-items: center;
  margin: 0 50px;
}
.memo > span {
  flex: 1;
}
.memo > div {
  flex: 6;
}
.sendmemo {
  text-align: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/TheContact.vue